import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "@/lib/utils"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef(({
  className,
  align = "center",
  sideOffset = 4,
  wrapperZIndex,
  ...props
}, ref) => {
  const contentRef = React.useRef(null)

  const setRefs = React.useCallback((node) => {
    contentRef.current = node
    if (typeof ref === "function") {
      ref(node)
      return
    }
    if (ref) {
      ref.current = node
    }
  }, [ref])

  React.useLayoutEffect(() => {
    if (wrapperZIndex == null) {
      return undefined
    }
    const wrapper = contentRef.current?.parentElement
    if (!wrapper) {
      return undefined
    }
    const previousZIndex = wrapper.style.zIndex
    wrapper.style.zIndex = String(wrapperZIndex)
    return () => {
      wrapper.style.zIndex = previousZIndex
    }
  }, [wrapperZIndex])

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={setRefs}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]",
          className
        )}
        {...props} />
    </PopoverPrimitive.Portal>
  )
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
